import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Heading, Text } from "@chakra-ui/react";
import BtechCollegeDetails from "../components/sections/BtechCollegeDetails";

const BtechDetailsPage = () => {
 const location = useLocation();
 const { college } = location.state || {};
 console.log("pdf:", college);

 // inside component
 useEffect(() => {
  if (location.state) {
   console.log("PDF from state:", location.state.college);
  } else {
   console.log("No location.state — possibly refreshed or accessed directly.");
  }
 }, [location.state]);

 return (
  <Box bg="gray.100" minH="100vh" py={8}>
   <Box maxW="container.xl" mx="auto" px={4}>
    {/* <Box textAlign="center" mb={8}>
     <Heading as="h1" size="xl" mb={2}>
      College Information Portal
     </Heading>
     <Text color="gray.600">
      Comprehensive details about top colleges in India
     </Text>
    </Box> */}

    <BtechCollegeDetails college={college} />
   </Box>
  </Box>
 );
};

export default BtechDetailsPage;
